import styles from "./TableRowRegistrationButton.module.scss";
import { Button } from "../common/Button";
import { useMemo, useState } from "react";
import { SelectStatus } from "../SelectStatus";
import { Link } from "react-router-dom";

const options = [
  { label: "Invited", value: "INVITED" },
  { label: "Accepted", value: "ACCEPTED" },
  {
    label: "Denied",
    value: "DENIED",
  },
];

const comany = "blue-tick";

export const TableRowRegistrationButton = () => {
  const [open, setOpen] = useState(false);
  const [status, setStatus] = useState(options[0]?.value);
  const toggleOpen = () => setOpen(!open);

  const handleChange = (value: string) => {
    setStatus(value);
    toggleOpen();
  };

  const statusLabel = useMemo(() => {
    return options.find((option) => option.value === status)?.label;
  }, [status]);

  return (
    <tr className={styles.row}>
      <td>
        <Link to={`/registration/${comany}`}>
          <Button className="dark">Bekijk hier</Button>
        </Link>
      </td>
      <td>
        <button className={styles.selectedStatus}>{statusLabel}</button>
      </td>
      <td>
        <Button className="dark" onClick={toggleOpen}>
          Wijzigen
          {open && (
            <SelectStatus
              options={options}
              onSave={handleChange}
              status={status}
            />
          )}
        </Button>
      </td>
    </tr>
  );
};
